<template>
    <vs-row
      vs-justify="center"
      vs-align="center"
      class="login-register-bg"
    >
      <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="5"
        vs-mc="7"
        vs-xs="12"
      >
      <h1 class="mb-3 h3 text-center" v-if="questionData != null">{{ questionData.name }}</h1>
        <vs-card class="position-relative mb-0 pt-5">
            <div class="back-button" v-if="step != 7">
                <vs-button icon="reply" color="danger" :title="'Back'" type="flat" @click="backClick">{{ $t('back') }}</vs-button>
            </div>

            <!-- question list -->
            <div v-if="step == 1 && questionData != null" class="login-register-box px-3">

                <div v-for="(question, index) in questionData.questions[0]" :key="index">

                    <div v-if="questionStep == index + 1">

                        <h3 class="text-center mb-3">{{ question.question_text }} ({{ questionStep + '/' + questionData.questions[0].length }})</h3>

                        <div v-if="question.question_type == 'checkbox'" :key="update">
                            <div class="w-100 mb-2" v-for="option in question.questions_options[0]" :key="option">
                                <vs-checkbox v-model="questionBody[index]['value']"  @change="checkBoxChange" class="justify-content-start" :vs-value="option">{{ option }}</vs-checkbox>
                            </div>
                        </div>

                        <div v-if="question.question_type == 'radio'" :key="update">
                            <div class="w-100 mb-2" v-for="option in question.questions_options[0]" :key="option">
                                <vs-radio v-model="questionBody[index]['value']" @change="checkBoxChange"   class="justify-content-start" :vs-value="option">{{ option }}</vs-radio>
                            </div>
                        </div>

                        <div v-if="question.question_type == 'integer' || question.question_type == 'number' || question.question_type == 'float'" :key="update">
                            <div class="w-100 mb-2">
                                <vs-input
                                    label=""
                                    type="number"
                                    v-model="questionBody[index]['value']"
                                    class="w-100 mt-3"
                                />
                            </div>
                        </div>

                        <div v-if="question.question_type == 'text'" :key="update">
                            <div class="w-100 mb-2">
                                <vs-input class="w-100" type="text" label="" v-model="questionBody[index]['value']"/>
                            </div>
                        </div>

                        <div v-if="question.question_type == 'textarea'" :key="update">
                            <div class="w-100 mb-2">
                                <vs-textarea class="w-100" label="" v-model="questionBody[index]['value']"/>
                            </div>
                        </div>

                        <div v-if="question.question_type == 'unit'" :key="update">
                            <div class="w-100 mb-2 d-flex align-items-center">
                                <vs-input type="number" v-model="questionBody[index]['value']"/>
                                &nbsp;<span>{{ questionBody[index]['question_value'] }}</span>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <!-- End of question list -->

            <!-- Description input section -->
            <div v-else-if="step == 2" class="login-register-box">
                <!-- <h3 class="mb-3 text-center">{{ questionData.name }}</h3> -->
                <h3 class="mb-3 text-center">{{ $t('heading_request') }}</h3>
                <vs-textarea class="w-100 mt-5 description" :counter="questionData.validation.description_max" v-model="description" height="150px"/>
                <vs-progress :percent="percent" :color="percent < 25 ? 'danger' : percent < 100 ? 'warning' : 'success' "></vs-progress>
                <p v-if="percent < 25" class="text-danger">{{ $t('valid_question2') }}</p>
                <p v-else-if="percent < 100" class="text-warning">{{ $t('valid_question3') }}</p>
                <p v-else class="text-success">{{ $t('valid_question1') }}</p>
            </div>
            <!-- End of Description input section -->

            <!-- location selection -->
            <div v-else-if="step == 3" class="login-register-box" :key="update">
                <!-- <h3 class="mb-3 text-center">{{ questionData.name }}</h3> -->
                <h3 class="mb-3 text-center">{{ $t('where_location') }}</h3>
                <vs-input class="w-100 mt-3" v-model="locationKeyword" @keyup="searchCity"/>
                <vs-card v-if="cityList.length != 0" style="z-index:5; max-height: 250px; overflow-y: auto; overflow-x: hidden">
                    <vs-button v-for="city in cityList" class="w-100 text-left" type="flat" :key="city.city.id" @click="selectCity(city)">{{ city.city.name + ', ' + city.city.region }}</vs-button>
                </vs-card>
                <div class="mt-3" v-else-if="locationKeyword.length < 3 && !selectedCity">{{ $t('inputThree') }}</div>
                <div class="mt-3" v-else-if="!selectedCity && cityList.length == 0">{{ $t('noSearchResult') }}</div>

                <div class="mt-3" v-if="selectedCity && cityList.length == 0">{{ $t('selected_city') }}: <strong>{{ selectedCity }}</strong></div>
            </div>
            <!-- End of location selection -->

            <div v-else-if="step == 4" class="login-register-box">
                <!-- <h3 class="mb-3 text-center">{{ questionData.name }}</h3> -->
                <h3 class="mb-3 text-center">{{ $t('when_job') }}</h3>

                <div class="w-100 mb-2">
                    <vs-radio v-model="whenNeed" class="justify-content-start" vs-value="soon_as_possible">{{ $t('asap') }}</vs-radio>
                </div>

                <div class="w-100 mb-2">
                    <vs-radio v-model="whenNeed" class="justify-content-start" vs-value="flexible">{{ $t('flexibleTime') }}</vs-radio>
                </div>

                <div class="w-100 mb-2">
                    <vs-radio v-model="whenNeed" class="justify-content-start" vs-value="in_two_month">{{ $t('inTwoMonth') }}</vs-radio>
                </div>

                <div class="w-100 mb-2">
                    <vs-radio v-model="whenNeed" class="justify-content-start" vs-value="in_six_month">{{ $t('inSixMonth') }}</vs-radio>
                </div>

                <div class="w-100 mb-2">
                    <vs-radio v-model="whenNeed" class="justify-content-start" vs-value="only_price">{{ $t('onlyPrice') }}</vs-radio>
                </div>

                <div class="w-100 mb-2">
                    <vs-radio v-model="whenNeed" class="justify-content-start" vs-value="specific_time">{{ $t('specificTime') }}</vs-radio>
                </div>

                <div v-if="whenNeed == 'specific_time'">
                    <vs-row>
                        <vs-col vs-xs="6" vs-lg="6">
                            <vs-input type="date" v-model="dateNeed" class="w-100"/>
                        </vs-col>
                        <vs-col vs-xs="6" vs-lg="6">
                            <vs-input type="time" v-model="timeNeed" class="w-100"/>
                        </vs-col>
                    </vs-row>
                </div>
                
            </div>

            <!-- phone number step  -->
            <div v-else-if="step == 5" class="login-register-box" style="overflow-x: hidden">
                <!-- <h3 class="mb-3 text-center">{{ questionData.name }}</h3> -->
                <h3 class="mb-3 text-center">{{ $t('enterPhoneNumber') }}</h3>
                
                <vs-input class="w-100 mt-5" v-model="phone" placeholder="+40123465789"/>
                <vs-select v-model="phoneOption" class="w-100 mt-3">

                    <vs-select-item value="allow_contacts" :text="$t('allow_contacts')"></vs-select-item>
                    <vs-select-item value="only_offers" :text="$t('only_offers')"></vs-select-item>
                    <vs-select-item value="only_phone" :text="$t('only_phone')"></vs-select-item>
                    <vs-select-item value="only_whatsapp" :text="$t('only_whatsapp')"></vs-select-item>
                    <vs-select-item value="dont_disturb_me" :text="$t('dont_disturbme')"></vs-select-item>
                   
                </vs-select>
                
            </div>
            <!-- End of phone number step  -->

            <!-- priority step -->
            <div v-else-if="step == -1" class="login-register-box">
                <!-- <h3 class="mb-3 text-center">{{ questionData.name }}</h3> -->
                <h3 class="mb-3 text-center">{{ $t('requestPriority') }}</h3>
                <!-- <p>Choose your payment plan according to the speed at which you need to find experts.</p> -->

                <div class="w-100 mb-2">
                    <vs-radio v-model="priority" class="justify-content-start" vs-value="FREE">{{ $t('free') }}</vs-radio>
                </div>

                <div class="w-100 mb-2">
                    <vs-radio v-model="priority" class="justify-content-start" vs-value="HIGH">{{ $t('high') }}</vs-radio>
                </div>
            </div>
            <!-- End of priority step -->

            <!-- Last step (email and name) -->
            <div v-else-if="step == 6" class="login-register-box">
                <!-- <h3 class="mb-3 text-center">{{ questionData.name }}</h3> -->
                <!-- <h3 class="mb-3 text-center">Fill your name and email</h3> -->
                
                <vs-input class="w-100 mt-2" v-model="fullName" :label="$t('name')" icon-after="true" icon="person"/>
                <vs-input
                    icon-after="true"
                    class="w-100 mt-2"
                    icon="email"
                    :label="$t('email')"
                    v-model="email"
                    type="email"
                />

                <vs-input
                    icon-after="true"
                    class="w-100 mt-2"
                    type="password"
                    icon="lock"
                    :label="$t('password')"
                    v-model="password"
                />
                <vs-input
                    icon-after="true"
                    class="w-100 mt-2"
                    type="password"
                    icon="lock"
                    :label="$t('confirmpassword')"
                    v-model="passwordConfirm"
                />
            </div>
            <!-- Last step -->

            <!-- Success  section -->
            <div v-else-if="step == 7" class="login-register-box">
                <div class="w-100 text-center">
                    <img src="@/assets/images/request_success.png" width="150px" />
                </div>
                <h3 class="mb-3 mt-5 text-center">{{ $t('Congratulation') }}</h3>
                <p class="text-center">{{ $t('request_success_msg') }}</p>
            </div>
            <!-- End of Success  section -->

            <div class="text-center mt-3" v-if="step != 7">
                <vs-button color="primary" class="w-100" @click="checkForm">
                    <span v-if="step == 6">{{ $t('sendRequest') }}</span>
                    <span v-else>{{ $t('lab_continue') }}</span>
                </vs-button>
            </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </template>
  
  <script>
  import axios from 'axios';


  export default {
    name: "Service",
    
    data: () => ({
        step: 1,
        questionStep: 0,     
        selectedService: [],
        questionData: null,
        questionBody: null,
        update: 0,
        description: '',
        locationKeyword: '',
        message: '',
        cityList: [],
        selectedCity: '',
        selectedCityId: null,
        whenNeed: 'soon_as_possible',
        dateNeed: '',
        timeNeed: '',
        phone: '',
        phoneOption: 'allow_contacts',
        priority: 'FREE',
        email: '',
        fullName: '',
        password: '',
        passwordConfirm: '',
    }),

    created() {
        axios
            .get(`${process.env.VUE_APP_API_URL}/public/service/${this.slug}`)
            .then(res => {
                this.questionData = res.data;
                document.title = `${this.questionData.name} | Recomand App`;
                if (this.questionData.questions[0].length == 0) {
                    this.questionStep = 0; // no question
                    this.step = 2;
                    return;
                }
                else {
                    this.questionStep = 1;
                    this.questionBody = this.questionData.questions[0];
                    for(let i = 0; i < this.questionData.questions[0].length; i++) {
                        if (this.questionBody[i]['question_type'] == 'checkbox') {
                            this.questionBody[i].value = [];
                        } else {
                            this.questionBody[i].value = "";
                        }
                    }
                }
            })
            .catch((err) => {
                this.message = JSON.stringify(err.response.data.message);
                this.$vs.notify({
                    color: "danger",
                    title: err.message,
                    text: this.message
                });
                this.$router.push(`/service`);
            });
    },

    methods: {
        selectService() {
            if(this.selectedService.length > 1) {
                const temp = this.selectedService[this.selectedService.length - 1];
                this.selectedService = [ temp ];
            }
        },

        searchCity() {
            if(this.locationKeyword.length > 2) {
                axios
                    .get(`${process.env.VUE_APP_API_URL}/public/location-autocomplete?search=${this.locationKeyword}`)
                    .then(res => {
                        this.cityList = res.data.data;
                        this.update++;
                    })
            }
        },

        selectCity(city) {
            this.selectedCity = city.city.name + ', ' + city.city.region;
            this.selectedCityId = city.city.id;
            this.cityList = [];
        },

        checkForm() {

            if ( this.step == 1 && this.questionStep != 0 ) {

                if (this.questionData.questions[0][this.questionStep - 1].is_required )  {
                
                    if(this.questionData.questions[0][this.questionStep - 1].question_type == 'checkbox'){
                        if ( this.questionData.questions[0][this.questionStep - 1].value.length == 0 ) {
                            this.$vs.notify({
                                color: "danger",
                                title: this.$t('requiredField'),
                                text: this.$t('requireDesc')
                            });
                            return;
                        } 
                    } else {
                        if ( this.questionData.questions[0][this.questionStep - 1].value == '' ) {
                            this.$vs.notify({
                                color: "danger",
                                title: this.$t('requiredField'),
                                text: this.$t('requireDesc')
                            });
                            return;
                        } 
                    }

                }
                

                if (this.questionStep < this.questionData.questions[0].length) {
                    this.questionStep ++ ;
                    return;
                }
            }

            if (this.step == 2) {
                if ( this.description == '') {
                    this.$vs.notify({
                        color: "danger",
                        title: this.$t('requiredField'),
                        text: this.$t('alert_description'),
                    });
                    return;
                }

                if ( this.description.length < this.questionData.validation.description_min) {
                    this.$vs.notify({
                        color: "danger",
                        title: this.$t('valid_question3'),
                        text: '',
                    });
                    return;
                }
            }

            if (this.step == 3) {
                if ( this.selectedCityId == null) {
                    this.$vs.notify({
                        color: "danger",
                        title: this.$t('enterCity'),
                        text: this.$t('location_validation'),
                    });
                    return;
                }
            }

            if (this.step == 4 && this.whenNeed == 'specific_time') {
                if ( this.dateNeed == '' || this.timeNeed == '') {
                    this.$vs.notify({
                        color: "danger",
                        title: this.$t('requiredField'),
                        text: this.$t('requireDesc'),
                    });
                    return;
                }
            }

            if (this.step == 5) {
                if ( this.phone == '') {
                    this.$vs.notify({
                        color: "danger",
                        title: this.$t('enterPhone'),
                        text: this.$t('kPhoneNumberNullError'),
                    });
                    return;
                }
            }

            if (this.step == 6) {

                if ( this.fullName == '') {
                    this.$vs.notify({
                        color: "danger",
                        title: this.$t('kNameNullError'),
                        text: this.$t('requiredField'),
                    });
                    return;
                }

                if ( this.email == '') {
                    this.$vs.notify({
                        color: "danger",
                        title: this.$t('kEmailNullError'),
                        text: this.$t('requiredField'),
                    });
                    return;
                } else if (!this.validEmail(this.email)) {
                    this.$vs.notify({
                        color: "danger",
                        title: this.$t('kInvalidEmailError'),
                        text: '',
                    });
                    return;
                }

                if ( this.password == '') {
                    this.$vs.notify({
                        color: "danger",
                        title: this.$t('pleaseenteryourpassword'),
                        text: '',
                    });
                    return;
                }

                if ( this.passwordConfirm == '') {
                    this.$vs.notify({
                        color: "danger",
                        title: this.$t('kConfirmPasswordError'),
                        text: '',
                    });
                    return;
                }

                if ( this.passwordConfirm != this.password) {
                    this.$vs.notify({
                        color: "danger",
                        title: this.$t('kMatchPassError'),
                        text: '',
                    });
                    return;
                }

                let postData = new FormData();

                const dateTimeValue = new Date(
                    `${this.dateNeed}T${this.timeNeed}:00`
                );

                if (this.questionBody == null) {

                }
                else if(this.questionBody.length != 0)
                    postData.append('questions',  JSON.stringify(this.questionBody));


                postData.append('full_name', this.fullName);
                postData.append('phone', this.phone);
                postData.append('email', this.email);
                postData.append('phone_options', this.phoneOption);
                postData.append('city_id', this.selectedCityId);
                postData.append('address',  '');
                postData.append('description', this.description);
                postData.append('when_need_date', dateTimeValue.toISOString());
                postData.append('when_need', this.whenNeed);
                postData.append('priority', this.priority);
                postData.append('password', this.password);

                axios
                    .post(`${process.env.VUE_APP_API_URL}/public/publish/${this.questionData.id}`, postData)
                    .then(res => {
                        this.message = res.data;
                        this.$vs.notify({
                            color: "success",
                            title: this.$t('Congratulation'),
                            text: this.$t('request_success_msg'),
                        });
                        this.step++;
                    })
                    .catch((err) => {
                        console.log('err');
                        console.log(err);
                        this.message = JSON.stringify(err.response.data.message);
                        this.$vs.notify({
                            color: "danger",
                            title: err.message,
                            text: this.message
                        });
                    })

                    return;
            }

            this.step++;
        },

        backClick() {
            if(this.step == 1) {
                if (this.questionStep == 1) {
                    this.$router.push(`/service`);
                    return;
                }
            }

            if ( this.step == 2 && this.questionStep == 0) {
                this.$router.push(`/service`);
                return;
            }

            if ( this.step == 2 && this.questionStep == this.questionData.questions[0].length) {
                this.step -- ;
                return;
            }

            if ( this.step == 1 && this.questionStep > 1) {
                this.questionStep -- ;
                return;
            }

            if(this.step == 2 && this.questionStep > 0) return;

            this.step--;
        },

        validEmail: function (email) {
            var re =
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
            return re.test(email);
        },
            
        checkBoxChange() {
            this.update++;

        }
    },
    computed: {
        slug: function () {
            var id = this.$route.params.slug;
            if (id == undefined) return "";
            else return id.slice(0, id.length);
        },

        percent: function () {
            const percent = this.description.length * 100 / this.questionData.validation.description_min;
            return percent > 100 ? 100 : percent;
        }
    },
  };
  </script>

  <style lang="scss">
  .login-register-bg {
    margin: 0 auto;
  }

  .login-register-box {
    max-height: 55vh !important;
    min-height: 55vh !important;
    overflow-y: auto;
  }

  .back-button {
    position: absolute;
    top: 10px;
    left: 10px; 
  }

  .description {
        .vs-textarea {
            height: 150px;
            overflow-y: auto;
        }
  }

  </style>
  
  